import { render, staticRenderFns } from "./CompleteForgotPassword.vue?vue&type=template&id=78c292aa"
import script from "./CompleteForgotPassword.vue?vue&type=script&lang=js"
export * from "./CompleteForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports